<template>
  <ion-page>
    <app-header back="home" title="운송사 운반비 현황" />
    <ion-content :fullscreen="true">
      <template v-if="isConnected">
        <ion-grid>
          <ion-row class="ion-justify-content-center">
              <ion-col size-md="1" size-xs="1.5">
                <span>기간</span>
              </ion-col>
              <ion-col size-md="2" size-xs="5">
                <ion-input class="calendar" v-model="frMonth" id="frMonth" readonly @click="popChange"><ion-icon :icon="calendar" ></ion-icon></ion-input>
                <ion-popover trigger="frMonth" @didDismiss="onWillDismissPopover">
                  <ion-datetime class="dateitem" id="datetime" display-format="YYYY-MM-DD" min="2021-01-01" 
                  v-model="frMonth" presentation="date" :show-default-buttons="true">
                  </ion-datetime>
                </ion-popover>
              </ion-col>
              <ion-col size-md="0.5" size-xs="0.5">
                <span>~</span>
              </ion-col>
              <ion-col size-md="2" size-xs="5">
                <ion-input class="calendar" v-model="seMonth" id="seMonth" readonly @click="popChange"><ion-icon :icon="calendar"></ion-icon></ion-input>
                <ion-popover trigger="seMonth" @didDismiss="onWillDismissPopover">
                  <ion-datetime class="dateitem" id="datetime" display-format="YYYY-MM-DD" min="2021-01-01" v-model="seMonth" presentation="date"
                  :show-default-buttons="true"></ion-datetime>
                </ion-popover>
              </ion-col>
              <ion-col size-md="3.5" size-xs="4">
                  <ion-input id="ddd" class="ion-text-center" readonly placeholder="착지 검색" style="text-align: right; align-items: center; margin: auto;"
                  @click="openModal" @ionInput="cgname($event)"></ion-input>
              </ion-col>
              <ion-col size-md="1.5" size-xs="4">
                <ion-button expand="block" class="excel" @click="exportToExcel"  color="success">엑셀변환</ion-button>
              </ion-col>
              <ion-col size-md="1.5" size-xs="4">
                <ion-button expand="block" @click="onReConnect" color="medium">조회</ion-button>
              </ion-col>
          </ion-row>
        </ion-grid>
        <vue-good-table
          class ="tableCss" 
          :columns="columns" 
          :rows="crcss" 
          :row-style-class="rowStyleFunction"
          :sort-options="{
            enabled: false,
          }"
          max-height="74vh"> 
       </vue-good-table>
      </template>
      <template v-else>
        <network-error v-on:@onReConnect="onReConnect" />
      </template>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonContent,
  IonPopover,
  IonCol,
  IonRow,
  IonGrid,
  IonIcon,
  IonInput,
  IonDatetime,
  onIonViewWillEnter,
  IonButton,
  modalController,
  onIonViewWillLeave,
  popoverController
} from '@ionic/vue';
import { defineComponent, reactive, ref, computed } from 'vue';
import { useStore } from 'vuex';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import { VueGoodTable } from 'vue-good-table-next';
import { UseCrcs } from '@/api/services/crcs';
import { setDateFormat, getDayOfWeek  } from '@/utils/dateFormatter';
import { calendar } from 'ionicons/icons';
import * as XLSX from 'xlsx';
import DplaceListModal from './modal/DplaceListModal.vue';
import { users } from '@/api/services/user';

export default defineComponent({
  components: {
    IonPage,
    IonContent,
    IonDatetime,
    IonPopover,
    IonGrid,
    IonIcon,
    IonCol,
    IonRow,
    IonInput,
    // IonSelectOption,
    // IonSelect,
    VueGoodTable,
    IonButton
  },
  setup() {
    const frMonth = ref(setDateFormat(new Date().setDate(1), 'YYYY-MM-DD')); 
    const seMonth = ref(setDateFormat(Date.now(), 'YYYY-MM-DD')); 
    const { isConnected, fetchDatas, year, month, crcss } = UseCrcs();
    const salenm = reactive({ title: '%25', });
    const flag = reactive({ code: '%25', });

    const store = useStore();
    const auth = computed(() => store.getters['auth/getData']);
    const { saveLog } = users();

    onIonViewWillEnter(async () => {
      saveLog(auth.value.id, '운송사운반비현황');
    });

    const form = reactive({
      modalState: false,
      popoverState: false
    });
    async function onWillDismiss() {
      form.modalState = false;
    }
    async function onWillDismissPopover() {
      form.popoverState = false;
    }
    async function modalChange() {
      form.modalState = true;
    }   

    async function popChange() {
      form.popoverState = true;
    }

    function customd01(row) {
      if (row.sale_qunt) return row.sale_qunt.toLocaleString('ko-KR', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    }

    function customd02(row) {
      if (row.slam) return row.slam.toLocaleString('ko-KR', { maximumFractionDigits: 2 });
    }

    function customd03(row) {
      if (row.vtam) return row.vtam.toLocaleString('ko-KR', { maximumFractionDigits: 2 });
    }

    function customd04(row) {
      if (row.hkam) return row.hkam.toLocaleString('ko-KR', { maximumFractionDigits: 2 });
    }

    function customd05(row) {
      if (row.c_cost) return row.c_cost.toLocaleString('ko-KR', { maximumFractionDigits: 2 });
    }

    function customdc(row) {
      if (row.c_cost || row.sale_qunt || row.hkam || row.vtam || row.slam ) return 'currency';
    }

    const columns = reactive([
      {
        label: '운송사',
        field: 'clntname',
        width: '100px',
      },
      {
        label: '착지',
        field: 'dplace_name',
        width: '120px',
      },
      {
        label: '품목',
        field: 'itnm',
        width: '71px',
      },
      {
        label: '운송량',
        field: customd01,
        width: '75px',
        tdClass: customdc,
      },
      {
        label: '단가',
        field: customd05,
        width: '75px',
        tdClass: customdc,
      },
      {
        label: '공급가',
        field: customd02,
        width: '100px',
        tdClass: customdc,
      },
      {
        label: '부가세',
        field: customd03,
        width: '100px',
        tdClass: customdc,
      },
      {
        label: '합계',
        field: customd04,
        width: '71px',
        tdClass: customdc,
      },
    ]);

    onIonViewWillEnter(async () => { // 들어오자 마자 검색? 일단 껐음.
      // const frdutiesPromise = fetchDatas(frMonth.value.substring(0, 10).replaceAll('-', ''), seMonth.value.substring(0, 10).replaceAll('-', ''), '', '');
      // await frdutiesPromise;
    });

    async function onReConnect() {
      const frdutiesPromise = fetchDatas(frMonth.value.substring(0, 10).replaceAll('-', ''), seMonth.value.substring(0, 10).replaceAll('-', ''), salenm.title == null ? '%25' : salenm.title );
      await frdutiesPromise;
    }

    const exportToExcel = () => {
      const data =  Object.values(crcss.value).map(row => [row.clntname, row.dplace_name, row.itnm, row.sale_qunt, row.c_cost, row.slam, row.vtam, row.hkam,]);
      data.unshift(columns.map(col => col.label));
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "운송사운반비현황.xlsx");
    }


    function cgname(e) {
      if (e == null) {
        document.querySelector('.ion-text-center').value = null;
      } else {
        document.querySelector('.ion-text-center').value = "[" + e + " ]";
      }
    }

    async function openModal() {
      const distinctDplaceCodes = Array.from(new Set(crcss.value.map(crcss => `${crcss.dplace_code} / ${crcss.dplace_name}`)
      .filter((dplaceCode) => !dplaceCode.includes("ZZZZZZ")).sort()
      ));

      form.modalState = true;
      const modal = 
        await modalController.create({
              component: DplaceListModal,
              componentProps:{
                seachingFlag: 'All',
                distinctDplaceCodes: distinctDplaceCodes
              }
        });
      modal.present();

      const { data, role } = await modal.onWillDismiss();

      if (role === 'confirm') {
        cgname(data.substring(8));
        salenm.title = data.substring(0, 7);
      } else {
        salenm.title = data;
        cgname(salenm.title);
      }
      form.modalState = false;
    }

    function rowStyleFunction(row) {
      if (row.sicdname === '[1공장 소계]' || row.sicdname === '[2공장 소계]' ) {
        return 'row-subtotal-color';
      } else if (row.dplace_name === '[합계]'){
        return 'row-total-color';
      } else if (row.clntname === '[총계]'){
        return 'row-all-total-color';
      }
    }
    onIonViewWillLeave(async () => {
      if (form.modalState == true) {
        await modalController.dismiss()
      } else if (form.popoverState == true) {
        await popoverController.dismiss()
      }
    });
    return {
      isConnected,
      year,
      month,
      frMonth,
      seMonth,
      columns,
      crcss,
      calendar,
      flag,
      rowStyleFunction,
      getDayOfWeek,
      onReConnect,
      exportToExcel,
      openModal,
      form,
      modalChange,
      onWillDismiss,
      onWillDismissPopover,
      popChange,
    };
  }
});

</script>
<style scoped>
.wonder-red {
  background-color: red !important;
}
.currency {
  color: black;
  text-align: right;
}
ion-content {
  text-align: center;
}
ion-col {
  padding: 0;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  color: black;
  width: 100%;
}
ion-col .calendar {
  padding: 0;
}
.title {
  display: block;
  text-align: center;
  font-size: 1.2em;
  padding: 0.5em;
}
ion-grid {
  padding: 0;
}
ion-datetime {
  width: 100%;
} 
ion-item {
  text-align: center;
}
</style>